import {Component, Inject, ViewChild} from '@angular/core';
import {defaultFileConfig, FileConfig, selfRoutes} from "../../models/config.model";
import {FormControl, FormGroup} from "@angular/forms";
import {EventBusService} from "../../../../../../../base/services/eventbus/event-bus.service";
import {ActivatedRoute, Router} from "@angular/router";
import {SubscriptionContainerService} from "../../../../../../../base/services/subscription-container.service";
import {FileService} from "../../services/file.service";
import {NotifierService} from "../../../../../../../base/services/notifier/notifier.service";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {BreadcrumbItem} from "../../../../generic/breadcrumb/breadcrumb.model";
import {EventKey} from "../../../../../../../registry/event.key";
import {HttpErrorResponse} from "@angular/common/http";
import {IFile, IImageSlice} from "../../models/file.model";
import {BaseConfig} from "../../../../../../../base/models/baseConfig";
import {BaseUpsertComponentV2} from "../../../../../../../base/components/base-upsert-v2.component";
import {ImageUploaderComponentV2} from "../image-uploader-v2/image-uploader-v2.component";

@Component({
  selector: 'app-file-upsert',
  templateUrl: './file-upsert.component.html',
  styleUrls: ['./file-upsert.component.scss']
})
export class FileUpsertComponent extends BaseUpsertComponentV2<IImageSlice[]> {

  config: FileConfig = defaultFileConfig

  @ViewChild(ImageUploaderComponentV2, {static: false})
  private uploadComponent: ImageUploaderComponentV2

  fileForm = new FormGroup({
    image: new FormControl<string | null>(null)
  })

  constructor(eventBus: EventBusService,
              router: Router,
              subContainer: SubscriptionContainerService,
              route: ActivatedRoute,
              private fileService: FileService,
              private notifier: NotifierService,
              @Inject(MAT_DIALOG_DATA) dialogData: any) {
    super(eventBus, router, subContainer, route, dialogData)
  }

  protected override componentName(): string {
    return "FileUpsertComponent"
  }

  protected override getBreadcrumbItems(): BreadcrumbItem[] {
    return [
      {
         text: this.translations["Dashboard"],
        link: null,
        active: false
      },
      {
        text: "Files",
        link: "/dash/files",
        active: false
      },
      {
        text: "Upsert",
        link: null,
        active: true
      }
    ]
  }

  override initialize(exId: number): void {
    this.loading = true
    let key = this.componentKey(EventKey.FILES.GET(exId))
    this.fileService.fetchSingle(key, exId)
    this.subscribe(key, null, (value, meta) => {
      this.loading = false;
      this.populateForm(meta.data)
    })
    this.subscribe(this.getErrorKey(key), null, (value, meta) => {
      let error: HttpErrorResponse = meta.data
      console.log(error)
      this.loading = false;
    })
  }

  getExImages(): IImageSlice[] {
    return [
      {
        image_url: this.fileForm.controls.image.value!!,
        thumb_url: this.fileForm.controls.image.value
      }
    ]
  }

  onSubmit() {
    if (!this.fileForm.valid) {
      return
    }
    this.uploadComponent.uploadImages()
  }

  onImgUploaded(images: IImageSlice[]) {
    if (images.length > 0) {
      this.fileForm.controls.image.setValue(images[0].thumb_url)
    }
    setTimeout(() => {
      this.onCompleted.emit(images)
    }, 500)
  }

  getConfig(): BaseConfig {
    return this.config;
  }

  getListPageRoute(): string {
    return selfRoutes.list;
  }

  private populateForm(n: IFile) {}

}
